import { IPostMedia } from '../dtos/IPostProjectProps';

export const POST_PLACEHOLDER_IMAGE =
  'https://fuzzyplaydev.s3.us-east-2.amazonaws.com/illustration+clean/card-empty-user-projects.jpg';

export type PostThumbnailKind = 'image' | 'video' | 'placeholder';

export interface IPostThumbnail {
  kind: PostThumbnailKind;
  url: string;
}

/**
 * Qual mídia representa o post num card.
 *
 * Imagem tem preferência: é um `<img>` de verdade, carrega mais leve e
 * funciona em qualquer contexto.
 *
 * Sem imagem, devolve o vídeo em vez do placeholder. A versão anterior caía
 * direto no placeholder, e como quase todo post da comunidade é só vídeo, a
 * home ficava com um mural de ilustrações genéricas. Quem renderiza precisa
 * usar `<video>` neste caso — apontar `<img>` para um .mp4 desenha o quadrado
 * quebrado, que foi o motivo de o fallback existir.
 *
 * O ideal continua sendo gerar um poster no upload; aí isto volta a ser
 * sempre 'image'.
 */
export function resolvePostThumbnail(photos: IPostMedia[]): IPostThumbnail {
  const image = photos?.find(media => media.media_type === 'image');

  if (image) return { kind: 'image', url: image.url };

  const video = photos?.find(media => media.media_type === 'video');

  if (video) return { kind: 'video', url: video.url };

  return { kind: 'placeholder', url: POST_PLACEHOLDER_IMAGE };
}
